export default __webpack_public_path__ + "static/media/about_master_yang-lrg.ed3a67e8.png";